import { I as t } from "../../constants-DeVuDy8J.js";
import { createElementBlock as r, openBlock as d, normalizeClass as n, createElementVNode as o } from "vue";
import { _ as s } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const l = {
  name: "DtIconServicenow",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (a) => Object.keys(t).includes(a)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return t[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, c = ["aria-label", "data-qa", "aria-hidden"], _ = /* @__PURE__ */ o("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M12.062 3C6.579 2.967 2.049 7.455 2 12.955a10.05 10.05 0 0 0 3.14 7.39c.707.674 1.809.74 2.581.14 1.135-.888 2.598-1.423 4.283-1.423 1.677 0 3.14.526 4.283 1.422.78.609 1.882.527 2.597-.147a10.044 10.044 0 0 0 3.124-7.292C22 7.513 17.553 3.033 12.062 3Zm-.058 15.06c-2.967 0-4.998-2.236-4.998-4.998s2.03-5.04 4.998-5.04c2.968 0 4.998 2.27 4.998 5.04 0 2.762-2.03 4.998-4.998 4.998Z",
  fill: "#83B6A2"
}, null, -1), m = [
  _
];
function u(a, f, i, p, h, e) {
  return d(), r("svg", {
    "aria-label": i.ariaLabel,
    class: n([e.iconSizeClass, "d-icon d-icon--servicenow"]),
    "data-qa": e.dataQA,
    "aria-hidden": e.ariaHidden,
    role: "img",
    "data-name": "Servicenow",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, m, 10, c);
}
const b = /* @__PURE__ */ s(l, [["render", u]]);
export {
  b as default
};
//# sourceMappingURL=servicenow.js.map
